<h2 mat-dialog-title>Enviar comando</h2>
<mat-dialog-content>
  <app-send-command [elementId]="data.elementId" (cancelled)="closeDialog()" (submitted)="onSubmit()"/>
</mat-dialog-content>
